export default __webpack_public_path__ + "static/media/D_01_01_map.df398f09.jpg";